import { createContext, useContext } from 'react'
import { DocletHostMedia } from './types'

interface DocletAssets {
  /**
   * Cloudinary cloud that uploaded images live in. Passed in by the app
   * rendering the doclet, so src/doclets doesn't read app config itself.
   */
  cloudinaryCloudName: string | null
  /**
   * The host media records the Media blocks play, by id. Also passed in by
   * the app, which looks them up (ShareDoclet.hostMedia).
   */
  hostMedia: Record<string, DocletHostMedia>
}

export const DocletAssetsContext = createContext<DocletAssets>({
  cloudinaryCloudName: null,
  hostMedia: {}
})

export const useDocletAssets = () => useContext(DocletAssetsContext)
